"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var types_1 = __importDefault(require("./types"));
var typesSocket_1 = __importDefault(require("./typesSocket"));
exports["default"] = {
    runCleaner: function () { return ({ type: types_1["default"].RUN_CLEANER }); },
    setMyself: function (user) { return ({ type: types_1["default"].SET_MYSELF, payload: user }); },
    setMessages: function (roomId, messages, isReplace) { return ({
        type: types_1["default"].SET_MESSAGES,
        payload: { roomId: roomId, messages: messages, isReplace: isReplace }
    }); },
    // setUserPresence: (id, status) => ({
    //   type: types.SET_USER_PRESENCE,
    //   payload: { id, status },
    // }),
    receivedNewMessages: function (messages) { return ({
        type: types_1["default"].MESSAGE_RECEIVED,
        payload: messages
    }); },
    addRoom: function (room) { return ({
        type: types_1["default"].ADD_ROOM,
        payload: room
    }); },
    deleteRoom: function (roomId) { return ({ type: types_1["default"].DELETE_ROOM, payload: roomId }); },
    // for 3rd party
    createMockDirectRoom: function (roomId, userId) { return ({
        type: types_1["default"].CREATE_MOCK_DIRECT_ROOM,
        payload: { roomId: roomId, userId: userId }
    }); },
    addUser: function (user) { return ({ type: types_1["default"].ADD_USER, payload: user }); },
    addUserToIgnored: function (username) { return ({
        type: types_1["default"].ADD_USER_TO_IGNORED,
        payload: username
    }); },
    setUnread: function (payload) { return ({
        type: types_1["default"].SET_UNREAD,
        payload: payload
    }); },
    setRoomMembers: function (roomId, members) { return ({
        type: types_1["default"].ROOM_MEMBERS_SET,
        payload: { roomId: roomId, members: members }
    }); },
    setRoomDirectOffset: function (offset) { return ({
        type: types_1["default"].SET_ROOM_DIRECT_OFFSET,
        payload: offset
    }); },
    setRoomGroupOffset: function (offset) { return ({
        type: types_1["default"].SET_ROOM_GROUPS_OFFSET,
        payload: offset
    }); },
    setChatUpdateTime: function (date) { return ({
        type: types_1["default"].SET_CHAT_UPDATE_TIME,
        payload: date
    }); },
    // queue
    addMessageToQueue: function (payload) { return ({
        type: types_1["default"].MESSAGE_QUEUE_ADD,
        payload: payload
    }); },
    removeMessageFromQueue: function (payload) { return ({
        type: types_1["default"].MESSAGE_QUEUE_REMOVE,
        payload: payload
    }); },
    setQueueError: function (payload) { return ({
        type: types_1["default"].MESSAGE_QUEUE_ERROR,
        payload: payload
    }); },
    // chat related
    socketOpened: function () { return ({ type: typesSocket_1["default"].SOCKET_OPEN }); },
    socketClose: function () { return ({ type: typesSocket_1["default"].SOCKET_CLOSE }); },
    socketSetState: function (isConnected) { return ({
        type: typesSocket_1["default"].SOCKET_CONNECT_STATE,
        payload: isConnected
    }); },
    socketWarnings: function (isEnabled) { return ({
        type: typesSocket_1["default"].SOCKET_WARNING_ENABLED,
        payload: isEnabled
    }); },
    // 3rd party
    setRoomMuted: function (room_id, is_muted) {
        if (is_muted === void 0) { is_muted = false; }
        return ({
            type: types_1["default"].SET_ROOM_MUTED,
            payload: { room_id: room_id, is_muted: is_muted }
        });
    }
};
